export default {
  // 客户标签管理
  客户标签管理: '客户标签管理',
  客户标签: '客户标签',
  客户数: '客户数',
  来源: '来源',
  系统预置: '系统预置',
  自主创建: '自主创建',
  新建标签: '新建标签',
  编辑标签: '编辑标签',
  标签名称: '标签名称',
  请输入标签名称: '请输入标签名称',
  '确定删除该标签?': '确定删除该标签?',
  标签名称不能为空: '标签名称不能为空',
  标签名称长度不能超过20个字符: '标签名称长度不能超过20个字符',

  提现中: '提现中',
  奖励编号: '奖励编号',
  奖励邀请: '奖励邀请',
  被邀请人注册账号: '被邀请人注册账号',
  被邀请人注册日期: '被邀请人注册日期',
  完成任务时间: '完成任务时间',
  注册时间: '注册时间',
  奖励金币: '奖励金币',
  奖励状态: '奖励状态',
  累计已获奖励金: '累计已获奖励金',
  去充值: '去充值',
  去提现: '去提现',
  生成链接: '生成链接',
  生成海报: '生成海报',
  保存海报: '保存海报',
  分享给你啦: '分享给你啦!',
  我的奖励明细: '我的奖励明细',
  '邀请注册成功(任务进行中)': '邀请注册成功(任务进行中)',
  任务失败: '任务失败',
  '红包最高 1000 元': '红包最高 1000 元',
  立即分享给好友可获: '立即分享给好友可获',
  系统自动发送: '系统自动发送',
  '有效期14天,逾期未提现将失效': '有效期14天,逾期未提现将失效',
  活动说明: '活动说明',
  活动奖励: '活动奖励',
  邀新活动1:
    '每成功邀请一位新用户(以下或称“好友”)使用手机号首次注册云展动力、下载安装APP、并于24小时内使用手机号登陆成功,您将获得金币红包奖励。',
  邀新活动2:
    '您可以将活动页面分享到微信好友或微信朋友圈(具体分享方式以平台内实际提供为准),被您邀请的好友通过您分享的链接或海报,使用手机号成功注册、安装并登陆云展动力APP,则视为邀请好友成功。',
  邀新活动3:
    '您也可以将您的专属邀请码分享给您的好友,您的好友成功填写您的邀请码并使用手机号成功注册、安装并登陆云展动力APP,则视为邀请好友成功。',
  邀新活动4: '邀请码为本平台为每位用户设立的独立唯一ID号,仅用于邀请好友时使用。',
  邀新活动5:
    '邀请新用户注册所获得的平台金币奖励属于活动赠送奖励,奖励自获得日起90天有效,逾期自动失效,请在有效期内在平台消费或提现。',
  邀新活动6:
    '每个新用户只能被成功邀请一次,同一个登录账号、同一个手机号、同一台设备、同一个IP地址、同一个提现账户,都视为同一个用户。',
  邀新活动7:
    '您账户中的金币数额达到提现额度后,可申请提现,提现通常会在15个工作日内到账,但您理解并同意如遇节假日或提现高峰期,提现到账时间可能会延长,请您谅解。',
  邀新活动8: '部分手机号或号码段不在本次活动范围内,请您谅解。',
  邀新活动9:
    '对于以任何不正当方式参与活动的用户,包括但不限于使用空号或无效手机号注册、侵犯甚至盗取第三人合法权益、作弊、扰乱系统、网络攻击等,云展动力有权拒绝此类用户的提现请求,追索既往所发放的平台奖励并保留追究法律责任的权利。',
  邀新活动10: '每位用户分享邀新所获金币奖励上限是1000金币,超过则不再获得奖励。',
  邀新活动11: ' 平台拥有活动的最终解释权。',
}
